import type { Campaign } from "../api";

/**
 * Failures nobody has accounted for.
 *
 * Every displayos-headless campaign was red for the same three BAWU cases
 * (goldens from layout v331, package v346) while the decision sat with OP, so
 * "not all green" stopped meaning anything and a fourth failure would have
 * looked the same. A known problem is still a failure; this is how many are
 * NOT known.
 */
export function newFailures(c: Pick<Campaign, "failed" | "known">): number {
  return Math.max(0, c.failed - (c.known ?? 0));
}

/** Everything planned ran, nothing was lost or skipped, and every failure is a
 *  known problem: the campaign has nothing new to say. */
export function onlyKnown(
  c: Pick<Campaign, "status" | "failed" | "known" | "lost" | "skipped" | "ran" | "planned">,
): boolean {
  return (
    c.status === "not_green" &&
    c.failed > 0 &&
    newFailures(c) === 0 &&
    !c.lost &&
    c.skipped === 0 &&
    c.planned !== null &&
    c.ran === c.planned
  );
}
